import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=5b73b05c&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=5b73b05c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b73b05c",
  null
  
)

export default component.exports